module.exports = __webpack_public_path__ + "static/level_2.fe086328.png";